import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AngularFireAuthGuard, redirectUnauthorizedTo } from "@angular/fire/compat/auth-guard";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { IonicModule, NavParams } from "@ionic/angular";
// import player from 'lottie-web';
// import { LottieServerModule } from 'ngx-lottie/server';

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import player from 'lottie-web';
import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import { ComponentModule } from "src/app/components/component.module";
import { FileUploadModule } from "src/app/components/file-upload/file-upload.module";
import { Fork1Page } from "src/app/components/fork1/fork1.page";
import { Fork2Page } from "src/app/components/fork2/fork2.page";
import { JoinedSyndicateComponent } from "src/app/components/joined-syndicate/joined-syndicate.component";
import { PickYourNumberComponent } from "src/app/components/pick-your-number/pick-your-number.component";
import { DirectiveModule } from "src/app/directives/directive.module";
import { CustomDatePipe } from "src/app/pipe/custom.datepipe";
import { TabsFirestoreService } from "src/app/services/tabs-firestore.service";
import { SwiperModule } from "swiper/angular";

import { JackpotChangeThresholdComponent } from "./jackpot-change-threshold/jackpot-change-threshold.component";
import { JackpotInfoPopupComponent } from "./jackpot-info-popup/jackpot-info-popup.component";
import { DontUnderstandComponent } from "./leave-syndicate-reasons/dont-understand/dont-understand.component";
import { DontWantToPlayComponent } from "./leave-syndicate-reasons/dont-want-to-play/dont-want-to-play.component";
import { NotWinningComponent } from "./leave-syndicate-reasons/not-winning/not-winning.component";
import { SomethingElseComponent } from "./leave-syndicate-reasons/something-else/something-else.component";
import { TooExpensiveComponent } from "./leave-syndicate-reasons/too-expensive/too-expensive.component";
import { WasNotAwareComponent } from "./leave-syndicate-reasons/was-not-aware/was-not-aware.component";
import { LeaveSyndicateComponent } from "./leave-syndicate/leave-syndicate.component";
import { ListOfChecksComponent } from "./list-of-checks/list-of-checks.component";
import { LottieplayerComponent } from "./lottieplayer/lottieplayer.component";
import { LuckySliderStepperComponent } from "./lucky-slider-stepper/lucky-slider-stepper.component";
import { LuckySlider1Component } from "./lucky-slider-stepper/lucky-slider1/lucky-slider1.component";
import { LuckySlider2Component } from "./lucky-slider-stepper/lucky-slider2/lucky-slider2.component";
import { LuckySlider3Component } from "./lucky-slider-stepper/lucky-slider3/lucky-slider3.component";
import { PauseSyndicateComponent } from "./pause-syndicate/pause-syndicate.component";
import { PaymentHolidayComponent } from "./payment-holiday/payment-holiday.component";
import { SyndicateAgreementComponent } from "./syndicate-agreement/syndicate-agreement.component";
import { SyndicateCardComponent } from "./syndicate-card/syndicate-card.component";
import { SyndicateGoldringComponent } from "./syndicate-goldring/syndicate-goldring.component";
import { SyndicateJackpotPopupComponent } from "./syndicate-jackpot-popup/syndicate-jackpot-popup.component";
import { SyndicateJackpotTriggerComponent } from "./syndicate-jackpot-trigger/syndicate-jackpot-trigger.component";
import { SyndicateLeaveFinalComponent } from "./syndicate-leave-final/syndicate-leave-final.component";
import { SyndicateLeaveComponent } from "./syndicate-leave/syndicate-leave.component";
import { SyndicatePauseComponent } from "./syndicate-pause/syndicate-pause.component";
import { SyndicatePreviousChecksComponent } from "./syndicate-previous-checks/syndicate-previous-checks.component";
import { SyndicateSettingComponent } from "./syndicate-setting/syndicate-setting.component";
import { SyndicateStatusComponent } from "./syndicate-status/syndicate-status.component";
import { SyndicateTicketPreviewComponent } from "./syndicate-ticket-preview/syndicate-ticket-preview.component";
import { SyndicateTicketsComponent } from "./syndicate-tickets/syndicate-tickets.component";
import { SyndicatePage } from "./syndicate.page";
import { TakeHolidayComponent } from "./take-holiday/take-holiday.component";
import { PrivateSyndicateTicketComponent } from "./tickets/private-syndicate-ticket/private-syndicate-ticket.component";
import { UnpauseSyndicateBottomsheetComponent } from "./unpause-syndicate-bottomsheet/unpause-syndicate-bottomsheet.component";
const redirectUnauthorizedToWelcome = () => redirectUnauthorizedTo(["welcome"]);
export function FirestoreTranslationsLoaderFactory() {
  return new TabsFirestoreService();
}
const routes: Routes = [
  {
    path: "",
    component: SyndicatePage,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "leaveSyndicate",
    component: LeaveSyndicateComponent,
  },
  {
    path: "lucky-slider1",
    component: LuckySlider1Component,
  },
  {
    path: "lucky-slider2",
    component: LuckySlider2Component,
  },
  {
    path: "lucky-slider3",
    component: LuckySlider3Component,
  },

  {
    path: "syndicateTicket",
    component: PrivateSyndicateTicketComponent,
  },

  {
    path: "lottieplayer",
    component: LottieplayerComponent,
  },
  {
    path: "fork1",
    component: Fork1Page,
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToWelcome,
    },
  },
  {
    path: "fork2",
    component: Fork2Page,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "payment-holiday",
    component: PaymentHolidayComponent,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "pause-syndicate",
    component: SyndicatePauseComponent,
    canActivate: [AngularFireAuthGuard],
  },
];

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentModule,
    ScrollingModule,
    FileUploadModule,
    DirectiveModule,
    SwiperModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: FirestoreTranslationsLoaderFactory,
        },
        defaultLanguage: "en",
        isolate: true,
        extend: true,
    }),
    LottieComponent,
    SyndicatePage,
    SyndicateSettingComponent,
    SyndicateAgreementComponent,
    SyndicateLeaveComponent,
    SyndicateTicketsComponent,
    ListOfChecksComponent,
    SyndicateStatusComponent,
    PauseSyndicateComponent,
    LeaveSyndicateComponent,
    DontUnderstandComponent,
    DontWantToPlayComponent,
    TooExpensiveComponent,
    NotWinningComponent,
    WasNotAwareComponent,
    SomethingElseComponent,
    PrivateSyndicateTicketComponent,
    SyndicateTicketPreviewComponent,
    TakeHolidayComponent,
    SyndicateLeaveFinalComponent,
    PickYourNumberComponent,
    JoinedSyndicateComponent,
    LottieplayerComponent,
    LuckySliderStepperComponent,
    LuckySlider1Component,
    LuckySlider2Component,
    LuckySlider3Component,
    JackpotInfoPopupComponent,
    SyndicateJackpotPopupComponent,
    UnpauseSyndicateBottomsheetComponent,
    JackpotChangeThresholdComponent,
    SyndicateGoldringComponent,
    SyndicatePreviousChecksComponent,
    SyndicateJackpotTriggerComponent,
    SyndicateCardComponent,
],
    providers: [
        CustomDatePipe,
        NavParams,
        provideLottieOptions({
            player: () => player,
        }),
    ],
})
export class SyndicatePageModule {}
export function playerFactory() {
  return player;
}
